import * as React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import ReactSVG from 'react-svg';

import './style.css';

export const Presentation: React.SFC = () => (
  <div className="landing-presentation">
    <Container>
      <div className="landing-presentation__background">
        <div className="landing-presentation__title">
          Learn the language of your dreams and never forget it with our revolutionary new app.
        </div>
        <Grid centered={true}>
          <Grid.Row>
            <Grid.Column computer={1} only="computer" />
            <Grid.Column computer={3} tablet={4} mobile={12}>
              <img className="landing-presentation__animation" src="assets/images/video-screenshot.gif" />
            </Grid.Column>
            <Grid.Column computer={2} tablet={3} only="tablet">
              <img className="landing-presentation__screenshots" src="assets/images/screenshot-02.png" />
            </Grid.Column>
            <Grid.Column computer={2} tablet={3} only="tablet">
              <img className="landing-presentation__screenshots" src="assets/images/screenshot-03.png" />
            </Grid.Column>
            <Grid.Column computer={4} only="computer">
              <ReactSVG className="landing-presentation__illustration" src="assets/images/illustration-home.svg" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </Container>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/presentational/views/Landing/sections/Presentation/index.tsx